import type { InterventionStateIndicatorProps } from "./intervention-indicator-state.type";

import { useHasCurrentUser } from "@/entities/current-user";
import { IconIndicator } from "@/ui/icon-indicator";
import "./intervention-indicator-state.style.less";

export const InterventionStateIndicator = ({
  intervention,
  isBig,
}: InterventionStateIndicatorProps) => {
  const hasCurrentUser = useHasCurrentUser(intervention.users);
  const isOnGoing = intervention.state === "Ongoing";

  return hasCurrentUser && isOnGoing ? (
    <div className="intervention-indicator-state">
      <IconIndicator type="availableOnMobile" isBig={isBig} />
    </div>
  ) : null;
};
